import type { ExpandOptions } from "@repo/apis/bag";

export const minimumBagExpansions: ExpandOptions = ["summary"];

export const fullBagExpansions: ExpandOptions = [
  "summary",
  "total",
  "getdeliveryoptions",
  "spendLevelDiscount",
  "address",
  "expiredItems",
];

export const buildBagExpansionsForApiInteraction = ({
  expand,
}: {
  expand?: boolean;
}): ExpandOptions => {
  return expand ? fullBagExpansions : minimumBagExpansions;
};
